import VeeValidate from 'vee-validate'
import companySerialNoChecker from '@/validate/companySerialNoChecker'

VeeValidate.Validator.extend('company_serial_no', {
    getMessage: field => 'The ' + field + ' value is not a company serial number.',
    validate: companySerialNoChecker
});

export default VeeValidate;